import * as PIXI from "pixi.js";
import { TouchPrimitive } from "../inputs/primitives/touch-primitive";
import { SurfaceRenderable2 } from "../rendering/pixi/primitives/renderable2";
import { Rect } from "./rect";
import { Margin } from "./margin";

type RectConstructor = ConstructorParameters<typeof Rect>[0];

export class DRect extends TouchPrimitive implements SurfaceRenderable2 {
  __colour: PIXI.ColorSource;
  __roundness: number;
  padding: Margin;
  __requiresFullRerender = false;
  rendered = false;
  zOrder: number;
  __strokeWidth: number
  __strokeColour: PIXI.ColorSource;

  static Z_COUNTER = 0;

  constructor(
    config: RectConstructor & {
      id?: string;
      colour?: PIXI.ColorSource;
      roundness?: number;
      padding?: Margin;
      requiresFullRerender?: boolean;
      zOrder?: number;
      strokeColor?: PIXI.ColorSource;
      strokeWidth?: number;
    },
  ) {
    super(config);
    this.zOrder = config.zOrder ?? (DRect.Z_COUNTER += 1);
    this.__requiresFullRerender = config.requiresFullRerender ?? false;
    if (config.id) this.id = config.id;
    this.padding = new Margin({ all: 0 });
    if (config.padding) {
      this.padding = config.padding;
    }
    this.__colour = config.colour ?? "#ff00ff";
    this.__roundness = config.roundness ?? 0;
    this.__strokeColour = config.strokeColor ?? "#ff00ff";
    this.__strokeWidth = config.strokeWidth ?? 0;
  }

  set colour(colour: PIXI.ColorSource) {
    this.__colour = colour;
    this.__changed();
  }

  get colour() {
    return this.__colour;
  }

  set roundness(roundness: number) {
    this.roundness = roundness;
    this.__changed();
  }

  get roundness() {
    return this.__roundness;
  }

  override __changed() {
    this.changed = true;
    this.markForRender();
  }

  setRendered() {
    this.rendered = true;
  }

  needsRender() {
    return !this.rendered;
  }

  requiresFullRerender(): boolean {
    return this.__requiresFullRerender;
  }

  markForRender() {
    this.rendered = false;
  }

  render(graphics: PIXI.Graphics) {
    this.rendered = true;
    graphics.roundRect(this.x, this.y, this.width, this.height, this.roundness)
        .fill({
        color: this.__colour,
        })
        .stroke({
          width: this.__strokeWidth,
          color: this.__strokeColour,
          alignment: 1
        })
    // graphics.rect(this.x, this.y, this.width, this.height)
  }
}
